import { render, staticRenderFns } from "./classQuality.vue?vue&type=template&id=486c857e&scoped=true&"
import script from "./classQuality.vue?vue&type=script&lang=js&"
export * from "./classQuality.vue?vue&type=script&lang=js&"
import style0 from "./classQuality.vue?vue&type=style&index=0&id=486c857e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c857e",
  null
  
)

export default component.exports